<template>
  <div class="m-home">
    <van-notice-bar
      left-icon="info-o"
      text="移动端精简版 · 完整功能请用电脑浏览器打开"
    />

    <section v-for="section in quickSections" :key="section.title" class="block">
      <div class="block-title">{{ section.title }}</div>
      <div class="chip-wrap">
        <a
          v-for="item in section.items"
          :key="item.url"
          class="chip"
          :href="item.url"
          :target="item.external ? '_blank' : '_self'"
          :rel="item.external ? 'noopener noreferrer' : null"
          @click="onChipClick($event, item)"
        >{{ item.name }}</a>
      </div>
    </section>

    <section v-for="group in linkGroups" :key="group.title" class="block">
      <div class="block-title">{{ group.title }}</div>
      <van-cell-group inset>
        <van-cell
          v-for="item in group.items"
          :key="item.url"
          :title="item.name"
          :label="item.host"
          is-link
          :url="item.url"
        />
      </van-cell-group>
    </section>
  </div>
</template>

<script>
export default {
  name: 'MobileHome',
  data() {
    return {
      quickSections: [
        {
          title: '快捷功能',
          items: [
            { name: '系统推荐', menu: 'system-recommend' },
            { name: '波段雷达', menu: 'window-ranking' },
            { name: '基金重仓', menu: 'fund' },
            { name: '重仓行业', menu: 'fund-industry' },
            { name: '日K查询', menu: 'kline' },
          ],
        },
        {
          title: '行情数据',
          items: [
            { name: '行情中心', url: 'https://quote.eastmoney.com/center/', external: true },
            { name: '全球股市', url: 'https://quote.eastmoney.com/center/qqzs.html', external: true },
            { name: '数据中心', url: 'https://data.eastmoney.com/center/', external: true },
            { name: '沪深港通', url: 'https://quote.eastmoney.com/center/hsgt.html', external: true },
          ],
        },
        {
          title: '数据快捷入口',
          items: [
            { name: '融资融券', url: 'https://data.eastmoney.com/rzrq/', external: true },
            { name: '龙虎榜单', url: 'https://data.eastmoney.com/stock/lhb.html', external: true },
            { name: '机构调研', url: 'https://data.eastmoney.com/jgdy/', external: true },
            { name: '财报', url: 'https://data.eastmoney.com/bbsj/', external: true },
          ],
        },
      ],
      linkGroups: [
        {
          title: '常用站点',
          items: [
            { name: '东方财富网', host: 'eastmoney.com', url: 'https://www.eastmoney.com/' },
            { name: '证券之星', host: 'stockstar.com', url: 'https://www.stockstar.com/home.htm' },
            { name: '新浪财经', host: 'finance.sina.com.cn', url: 'https://finance.sina.com.cn/' },
            { name: '天天基金', host: '1234567.com.cn', url: 'https://www.1234567.com.cn/' },
          ],
        },
      ],
    }
  },
  methods: {
    onChipClick(e, item) {
      if (!item.menu) return
      e.preventDefault()
      this.$emit('navigate', item.menu)
    },
  },
}
</script>

<style scoped>
.m-home {
  padding-bottom: 12px;
}

.block {
  margin-top: 12px;
}

.block-title {
  padding: 8px 16px 6px;
  font-size: 14px;
  font-weight: 600;
  color: #323233;
}

.chip-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 16px 4px;
}

.chip {
  display: inline-flex;
  align-items: center;
  padding: 8px 12px;
  border-radius: 16px;
  background: #fff;
  color: #1989fa;
  font-size: 13px;
  text-decoration: none;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
</style>
